export default __webpack_public_path__ + "static/web-development-img-a077c79c346b87ecbfa2487090c0621c.webp";